import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <section id="reviews" className="relative py-20 sm:py-28 overflow-hidden" data-testid="testimonials-section">
      <div className="pointer-events-none hidden sm:block absolute top-0 right-1/4 h-[420px] w-[420px] rounded-full bg-azo-primary/10 blur-[130px]" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="max-w-2xl">
          <Reveal className="flex items-center gap-2 text-azo-primary font-mono2 text-xs uppercase tracking-widest mb-4">
            <span className="h-px w-8 bg-azo-primary" /> 04 — Customer Love
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-5xl leading-[1.05]">
              Bihar bharosa karta hai <span className="text-gradient">AzoApp</span> par.
            </h2>
          </Reveal>
          <Reveal delay={0.2} className="mt-5 text-azo-muted max-w-lg">
            10,000+ homes me services delivered. Yahan hain kuch real customers ki, unke apne words me.
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 3) * 0.1}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="group relative h-full rounded-3xl border border-azo-border bg-azo-surface p-7 shadow-azo transition-all duration-300 hover:-translate-y-1.5 hover:border-azo-primary"
              >
                <Quote className="absolute right-6 top-6 text-azo-primary/15 group-hover:text-azo-primary/25 transition-colors" size={44} />
                <div className="flex items-center gap-1 text-azo-amber mb-4">
                  {Array.from({ length: t.rating }).map((_, s) => (
                    <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <blockquote className="relative text-[15px] leading-relaxed text-azo-text/90">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-azo-border pt-5">
                  <span className="grid h-11 w-11 place-items-center rounded-full bg-azo-primary/12 text-azo-primary font-heading font-bold">
                    {t.name.charAt(0)}
                  </span>
                  <div className="leading-tight">
                    <p className="font-heading font-semibold text-sm">{t.name}</p>
                    <p className="text-xs text-azo-muted">{t.service} · {t.city}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
